import React, { useEffect } from "react";
import { connect } from "react-redux";

import "../InfoPageLayout.css";
import { getMyFirmData } from "../../actions/tenantActions";
import FirmNameSection from "./FirmNameSection";
import FirmDocumentsSection from "./FirmDocumentsSection";
import FirmLocationsTable from "./FirmLocationsTable";
import FirmInfoSection from "./FirmInfoSection";
import SectionHeading from "../SectionHeading";

const MyFirm = ({ getMyFirmData }) => {
	useEffect(() => {
		// the API layer surfaces its own error toast; swallow here so a failed
		// load isn't an unhandled rejection
		getMyFirmData().catch(() => {});
	}, [getMyFirmData]);

	return (
		<div className="InfoPageLayout">
			<div className="InfoPageColumn">
				<FirmNameSection />
				<div style={{ marginTop: 32 }}>
					<FirmDocumentsSection />
				</div>
				<div style={{ marginTop: 32 }}>
					<SectionHeading divider>Locations</SectionHeading>
					<FirmLocationsTable />
				</div>
			</div>
			<div className="InfoPageSideColumn">
				<FirmInfoSection />
			</div>
		</div>
	);
};

export default connect(null, { getMyFirmData })(MyFirm);
